import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TagsState } from './tags.state';

export const selectTagsState = createFeatureSelector<TagsState>('adminTags');

export const selectAllTags = createSelector(
  selectTagsState,
  (state) => state.tags,
);

export const selectTagsLoading = createSelector(
  selectTagsState,
  (state) => state.loading,
);

export const selectTagsError = createSelector(
  selectTagsState,
  (state) => state.error,
);

export const selectTagsPagination = createSelector(
  selectTagsState,
  (state) => state.pagination,
);
